import { useTranslation } from 'react-i18next';
import { useAppStore } from '../store/useAppStore';
import {
  getRemainingSeconds,
  getBakingProgress,
  isOvertime,
  getBakingTimerLabel,
  getDefaultDuration,
} from '../utils/bakingTime';

export function useBakingTimer(order) {
  const { t } = useTranslation();
  // Only ticking orders need the per-second `now`; for all other states the
  // selector returns a constant so Zustand skips re-renders.
  const now = useAppStore((state) => (order?.state === 'baking' ? state.now : null));
  const config = useAppStore((state) => state.config);
  const defaultDuration = getDefaultDuration(config);

  const remaining = getRemainingSeconds(order, now, defaultDuration);

  return {
    remaining,
    label: getBakingTimerLabel(order, remaining, defaultDuration, t),
    progress: getBakingProgress(order, remaining ?? 0, defaultDuration),
    overtime: isOvertime(remaining),
  };
}
